"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filler = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  height: ${({ theme }) => theme.spacing.s1}px;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ theme }) => theme.constants.zindex.nprogressBar};
`;
exports.Filler = styled_components_1.default.div `
  width: ${({ width }) => width}%;
  height: 100%;
  background: ${({ theme }) => theme.palette.BLUE_100};
  opacity: ${({ isShown }) => (isShown ? 1 : 0)};
  pointer-events: none;
  transition: width 0.5s ease-in-out;
`;
exports.default = { Filler: exports.Filler, Container: exports.Container };
